/**
 * 格式化日期为简短格式（例如：'2024-03-07' -> 'Mar7'）
 * 注意：使用 UTC 时区解析，避免时区差异导致日期偏移
 * @param dateString - ISO 格式的日期字符串（YYYY-MM-DD）
 * @returns 格式化后的日期字符串（例如：'Mar7'）
 * @example formatDateShort('2024-03-07') // 'Mar7'
 */
export function formatDateShort(dateString: string): string {
  const date = new Date(`${dateString}T00:00:00Z`) // 强制使用 UTC 时区
  const month = date.toLocaleString('en-US', {
    month: 'short',
    timeZone: 'UTC',
  })
  const day = date.getUTCDate()
  return `${month}${day}`
}

/**
 * 格式化日期时间为完整格式（例如：'2026-01-14T08:28... ' -> 'Jan 14, 2026, 08:28'）
 * @param dateString - ISO 格式的日期时间字符串
 * @returns 格式化后的日期时间字符串
 */
export function formatFullDateTime(dateString: string): string {
  if (!dateString) return '-'
  const date = new Date(dateString)
  if (isNaN(date.getTime())) return '-'

  const options: Intl.DateTimeFormatOptions = {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  }

  return date.toLocaleString('en-US', options)
}
